import { render } from "./AgreementDatatableFormText.vue?vue&type=template&id=a2c181a8"
import script from "./AgreementDatatableFormText.vue?vue&type=script&lang=js"
export * from "./AgreementDatatableFormText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__